import { Input } from "antd";
import LabelRequired from "../../Common/LabelRequired";
import txtIcon from "../../../images/file-txt-icon.png";

interface ExtensionPluginConfirmProps {
  fileName: string;
  agentName: string;
  agencyEmail: string;
  serialNumber: string;
  hwNumber: string;
}

export default function ExtensionPluginConfirm({
  serialNumber,
  hwNumber,
  fileName,
  agentName,
  agencyEmail,
}: ExtensionPluginConfirmProps) {
  return (
    <div className="p-6 bg-[#F4F6F9] border border-[#BCC2FF] rounded-2xl">
      <div className="flex items-center mb-4">
        <span className="text-[#2C3A4B] text-sm font-medium">{fileName}</span>
        <img className="h-6" src={txtIcon} alt="txtIcon" />
      </div>

      <div className="flex gap-8">
        <div className="flex flex-col w-1/2 gap-6 [&>div]:max-h-[90px] [&>div]:min-h-[90px]">
          <div>
            <LabelRequired required={false} text="Camera serial number" />
            <Input
              type="text"
              className="w-full h-[46px]"
              disabled
              value={serialNumber}
            />
          </div>
          <div>
            <LabelRequired required={false} text="Agent name" />
            <Input
              value={agentName}
              type="text"
              disabled
              className="w-full h-[46px]"
            />
          </div>
        </div>
        <div className="flex flex-col gap-6 w-1/2 [&>div]:max-h-[90px] [&>div]:min-h-[90px]">
          <div>
            <LabelRequired required={false} text="HW serial number" />
            <Input
              type="text"
              className="w-full h-[46px]"
              disabled
              value={hwNumber}
            />
          </div>
          <div>
            <LabelRequired
              required={false}
              text="Agency contact email address"
            />
            <Input
              value={agencyEmail}
              type="text"
              disabled
              className="w-full h-[46px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
